// @flow
import * as React from 'react';

const VDivider: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`h-full w-[1px] bg-secondary-background ${className}`} />
);

export default VDivider;
